import React, { FunctionComponent, ReactNode } from 'react';
import { Modal } from 'react-bootstrap';
import { IBindingAction } from '../../common/models/callback';
import styles from './styles.module.scss';
import Icon from '../Icon';

interface IProps {
  isShown: boolean;
  onHide: IBindingAction;
  children: ReactNode;
  contentClassName?: string;
  modalClassName?: string;
  hideCloseBttn?: boolean;
}

const ModalWindow: FunctionComponent<IProps> = ({
  isShown,
  onHide,
  children,
  contentClassName = '',
  modalClassName = '',
  hideCloseBttn = false
}) => {
  const closeIcon = (
    <div
      role="presentation"
      onClick={onHide}
    >
      <Icon icon="close" className={`${styles.closeBttn} modal-close-button`} />
    </div>
  );
  return (
    <Modal
      className={modalClassName}
      centered
      dialogClassName={`${styles.modal} ${contentClassName}`}
      enforceFocus={false}
      show={isShown}
      onHide={onHide}
    >
      {!hideCloseBttn && closeIcon }
      <Modal.Body bsPrefix={styles.modalBody}>
        {children}
      </Modal.Body>
    </Modal>
  );
};

export default ModalWindow;
